'use client'

interface RangeInputProps {
  minValue: number | null
  maxValue: number | null
  onMinChange: (value: number | null) => void
  onMaxChange: (value: number | null) => void
  minPlaceholder?: string
  maxPlaceholder?: string
  label?: string
  prefix?: string
}

export function RangeInput({
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  minPlaceholder = 'Min',
  maxPlaceholder = 'Max',
  label,
  prefix = '$',
}: RangeInputProps) {
  const font = { fontFamily: 'var(--font-inter, Inter, sans-serif)' }

  const handleChange = (setter: (v: number | null) => void) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.trim()
    setter(val === '' ? null : parseInt(val, 10) || null)
  }

  return (
    <div>
      {label && (
        <label className="mb-1 block text-xs font-medium text-[var(--color-text-muted)]" style={font}>
          {label}
        </label>
      )}
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          {prefix && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-[var(--color-text-muted)]">{prefix}</span>
          )}
          <input
            type="number"
            value={minValue ?? ''}
            onChange={handleChange(onMinChange)}
            placeholder={minPlaceholder}
            className="w-full rounded-[var(--radius-md)] border border-[var(--color-border-default)] bg-[var(--color-bg-surface)] py-2 pl-7 pr-3 text-sm text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] focus:border-[var(--color-brand-indigo)] focus:outline-none"
            style={font}
            min={0}
          />
        </div>
        <span className="text-xs text-[var(--color-text-muted)]">to</span>
        <div className="relative flex-1">
          {prefix && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-[var(--color-text-muted)]">{prefix}</span>
          )}
          <input
            type="number"
            value={maxValue ?? ''}
            onChange={handleChange(onMaxChange)}
            placeholder={maxPlaceholder}
            className="w-full rounded-[var(--radius-md)] border border-[var(--color-border-default)] bg-[var(--color-bg-surface)] py-2 pl-7 pr-3 text-sm text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] focus:border-[var(--color-brand-indigo)] focus:outline-none"
            style={font}
            min={0}
          />
        </div>
      </div>
    </div>
  )
}
